const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/my',
    component: Import('my/index'),
    name: 'myIndex',
    meta: { title: '个人中心' }
  },
  {
    path: '/h5/my/modifyPwd',
    component: Import('my/modifyPwd'),
    name: 'modifyPwd',
    meta: { title: '修改密码' }
  },
  {
    path: '/h5/my/orderDetail/:orderId',
    component: Import('my/orderDetail'),
    name: 'orderDetail',
    meta: { title: '订单详情' }
  },
  {
    path: '/h5/my/upload',
    component: Import('my/upload'),
    name: 'myUpload',
    meta: { title: '上传的材料' }
  },
  {
    path: '/h5/my/collect',
    component: Import('my/collect'),
    name: 'myCollect',
    meta: { title: '我的收藏' }
  },
  {
    path: '/h5/my/bid',
    component: Import('my/bid'),
    name: 'myBid',
    meta: { title: '申办人信息' }
  },
  {
    path: '/h5/my/relation',
    component: Import('my/relation'),
    name: 'myRelation',
    meta: { title: '我的关系人' }
  },
  {
    path: '/h5/my/relationDetail/:relationId',
    component: Import('my/relationDetail'),
    name: 'myRelationDetail',
    meta: { title: '我的关系人' }
  },
  {
    path: '/h5/my/relationEdit/:relationId',
    component: Import('my/relationEdit'),
    name: 'myRelationEdit',
    meta: { title: '我的关系人' }
  },
  {
    path: '/h5/my/fee',
    component: Import('my/fee'),
    name: 'myFee',
    meta: { title: '费用详情' }
  },
  {
    path: '/h5/my/book',
    component: Import('my/book'),
    name: 'myBook',
    meta: { title: '文书' }
  },
  {
    path: '/h5/my/material/:orderId',
    component: Import('my/material'),
    name: 'myMaterial',
    meta: { title: '订单材料' }
  },
  {
    path: '/h5/my/pay',
    component: Import('my/pay'),
    name: 'myPay',
    meta: { title: '订单支付' }
  },
  {
    path: '/h5/my/msg/:orderId',
    component: Import('my/msg'),
    name: 'myMsg',
    meta: { title: '订单留言' }
  },
  {
    path: '/h5/my/set',
    component: Import('my/set'),
    name: 'mySet',
    meta: { title: '设置' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/my.js